export const SaleOrderValidation = (formData) => {
    const errors = {};
    if (formData.formData.ClientType.toString() === "0") {
        if (!formData.formData.CustomerID || formData.formData.CustomerID === "0") {
            errors.CustomerID = 'This field is required';
        }

        if (!formData.formData.FK_ClientBranch_ID || formData.formData.FK_ClientBranch_ID === "0") {
            errors.FK_ClientBranch_ID = 'This field is required';
        }
        if (!formData.formData.FK_ClientContact_ID || formData.formData.FK_ClientContact_ID === "0") {
            errors.FK_ClientContact_ID = 'This field is required';
        }
    }
    if (!formData.formData.dt_SalesOrderDate.trim()) {
        errors.dt_SalesOrderDate = 'This field is required';
    }
    if (!formData.formData.FK_SalesOrderType_ID || formData.formData.FK_SalesOrderType_ID == "0") {
        errors.FK_SalesOrderType_ID = 'This field is required';
    }
    return errors;
};
